export default __webpack_public_path__ + "static/media/8.a2c5c24e.jpg";